import { useState, useEffect, useCallback, useRef } from 'react';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { AUTH_API } from '../api/amplify';
import { setCognitoUserAuthorized, setCognitoUserMetadata } from '../store/CognitoSlice';
import { useAppDispatch } from './reduxTooklitHooks';

export const useCheckIsUserAuthorized = (onUserAuthorized?: () => void) => {
  const ignore = useRef(false);

  const dispatch = useAppDispatch();
  const [isUserAuthorizedChecking, setIsUserAuthorizedChecking] = useState(true);

  const checkIsUserAuthorized = useCallback(async () => {
    try {
      const response: CognitoUser = await AUTH_API.checkUser();
      const idToken = response?.getSignInUserSession()?.getIdToken();
      const token = idToken?.getJwtToken();

      if (token) {
        dispatch(setCognitoUserAuthorized());

        const metadata = {
          picture: idToken?.payload.picture,
          name: idToken?.payload.name,
          emailVerified: idToken?.payload.email_verified,
          isUsedSocialProviders: Boolean(idToken?.payload.identities?.length),
        };

        dispatch(setCognitoUserMetadata(metadata));

        if (onUserAuthorized) {
          onUserAuthorized();
        }
      }
      // we need a catch block, because if a user is not authorized, there will be an error here
      // eslint-disable-next-line no-empty
    } catch (e) {}

    setIsUserAuthorizedChecking(false);
  }, [dispatch, onUserAuthorized]);

  useEffect(() => {
    if (!ignore.current) {
      checkIsUserAuthorized();
    }

    return () => {
      ignore.current = true;
    };
  }, [checkIsUserAuthorized]);

  return {
    isUserAuthorizedChecking,
  };
};
